import _ from "lodash";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTypedDispatch } from "../../../app/state";
import { Save } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { selectCurrentLicence, selectCurrentLicenceId } from "../../../store/licenceStore/licenceSelectors";
import HorizontalPanel from "../../../components/HorizontalPanel";
import { Toolbar } from "../../../app/components";
import LicenceForm from "../LicenceForm";
import { createLicence, updateLicence } from "../../../store/licenceStore/licenceRequests";
import { selectCurrentLocationId } from "../../../store/locationStore/locationSelectors";
import LicenceModel from "../../../models/LicenceModel";
import { pagePathGenerator } from "../../../routes/pagePathGenerator";
import { getLicenceValidation } from "./validation";
import BreadcrumbsContainer from "../../Shared/BreadcrumbsContainer";
import CancelIcon from "@material-ui/icons/Cancel";

const LicenceCentralPanel = () => {
  const history = useHistory();
  const dispatch = useTypedDispatch();
  const currentLicence = useSelector(selectCurrentLicence);
  const currentLicenceId = useSelector(selectCurrentLicenceId);
  const currentLocationId = useSelector(selectCurrentLocationId);
  const toolBarTitle = currentLicenceId === -1 ? 'Create Licence' : 'Licence details';

  const licenceFormik = useFormik({
    initialValues: {
      name: currentLicence?.name || '',
      technologyId: currentLicence?.technologyId || 0,
      responsiblePeople: (currentLicence?.responsiblePeople || []).map((user) => user.id),
      issueDate: currentLicence?.issueDate || null,
      expirationDate: currentLicence?.expirationDate || null,
      notifyInDays: currentLicence?.notifyInDays || 0,
      description: currentLicence?.description || '',
    },
    onSubmit: () => {},
    validationSchema: getLicenceValidation(),
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const onSaveButtonClick = async () => {
    if (!currentLocationId) {
      return;
    }

    const valid = await licenceFormik.validateForm();

    if (!_.isEmpty(valid)) {
      return;
    }

    if (currentLicenceId && currentLicenceId !== -1) {
      // edit

      dispatch(
        updateLicence(
          {
            ...licenceFormik.values,
            responsiblePeople: licenceFormik.values.responsiblePeople,
            locationId: currentLicence?.locationId || currentLocationId,
            id: currentLicenceId,
          }
        )
      );

      return;
    }

    const action = await dispatch(
      createLicence(
        {
          ...licenceFormik.values,
          responsiblePeople: licenceFormik.values.responsiblePeople,
          locationId: currentLocationId,
        }
      )
    );

    const licence = action.payload as unknown as LicenceModel;

    const url = pagePathGenerator.LICENCE_PAGE({
      locationId: currentLocationId,
      licenceId: licence.id,
    });

    history.replace(url);
  }

  const onReset = () => {
    licenceFormik.resetForm();
  }

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <BreadcrumbsContainer items={[ BreadcrumbsContainer.TYPES.LOCATION, BreadcrumbsContainer.TYPES.LICENCE ]} />
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title={toolBarTitle}>
          <IconButton
            disabled={!licenceFormik.dirty}
            onClick={onReset}
            color="secondary"
            size="small"
            aria-label="Cancel"
          >
            <CancelIcon />
          </IconButton>
          <IconButton
            disabled={!licenceFormik.dirty}
            aria-label='save device changes'
            color='secondary'
            size='small'
            onClick={onSaveButtonClick}
          >
            <Save />
          </IconButton>
        </Toolbar>
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <LicenceForm licenceFormik={licenceFormik} />
      </HorizontalPanel>
    </HorizontalPanel>
  );
}

export default LicenceCentralPanel;